import alt from "../alt";

class EventActions {
  constructor() {
    this.generateActions(
      "updateEvents",
      "fetchMarquee",
      "fetchAll",
      "fetchAllForFilm",
      "fetchFailed",
      "clearNoAllOverwrite"
    );
  }

  updateEvent(id, event) {
    return { id, event };
  }

  fetchOne(id, options) {
    return { id, options };
  }
}

export default alt.createActions(EventActions);



// WEBPACK FOOTER //
// ./src/app/actions/EventActions.js